import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Button } from '@material-ui/core';
import { InputAdornment, TextField } from '@material-ui/core';
import './Notify-Popup.scss';
import { stripHtmlTags } from '../../utils/formUtils';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: '45%',
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const NotifyPopup = (props) => {
  const { notifyPopup, onNotify, onNotNotify } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [delayReason, setDelayReason] = useState({
    changeStatus: false,
    value: '',
  });

  const onSubmit = (e) => {
    e.preventDefault();
    onNotify(delayReason.value);
    setDelayReason({ changeStatus: false, value: '' });
  };

  const handleClose = () => {
    setDelayReason({ changeStatus: false, value: '' });
    onNotNotify();
  };

  return (
    <Modal open={notifyPopup.status} onClose={handleClose}>
      <div style={modalStyle} className={classes.paper}>
        <div className='notify-popup'>
          <div className='notify-popup-title'>{notifyPopup.title}</div>
          <p className='notify-popup-description'>{notifyPopup.description}</p>
          <form onSubmit={onSubmit}>
            <div className='row'>
              <div className='col-md-12 mb-3'>
                <TextField
                  value={delayReason.value}
                  multiline={true}
                  required={true}
                  fullWidth
                  onChange={(e) =>
                    setDelayReason({
                      changeStatus: true,
                      value: stripHtmlTags(e.target.value),
                    })
                  }
                  error={delayReason.changeStatus && delayReason.value === '' ? true : false}
                  className='delay-reason-input'
                  helperText={
                    delayReason.changeStatus && delayReason.value === ''
                      ? 'Please add reason'
                      : undefined
                  }
                  type='text'
                  variant='outlined'
                  rows={6}
                  inputProps={{ maxLength: 350 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <span className='cusotm-text-field-end-adornment'>{`${
                          delayReason.value.length
                        }/${350}`}</span>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div className='col-md-12 d-flex justify-content-end px-4 mt-4'>
              <Button
                variant='outlined'
                size='large'
                color='secondary'
                onClick={(e) => handleClose()}
                type='button'
              >
                Don't Notify
              </Button>
              <Button
                variant='contained'
                size='large'
                color='primary'
                className='ms-4'
                type='submit'
                disabled={!delayReason.value}
              >
                Notify
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default NotifyPopup;
